module.exports = __webpack_public_path__ + "img/thumb_2020-03.67a63c87.jpg";